/**
 * @file Hook de formatage monétaire lié à la devise de la company active.
 * @module packages.common.hooks.useCurrencyFormatter
 *
 * Fournit des fonctions `fCurrency` et `eCurrency` déjà liées à la devise
 * courante. À utiliser dans les nouveaux composants ou lors de refactorisations
 * explicites pour un formatage currency-aware sans passer la devise à la main.
 */

import useSessionStore from '../stores/sessionStore';
import {fCurrency, eCurrency} from '../utils/formatNumber';
import {getCurrencySymbol} from '../config/currencies';

/**
 * Retourne des formateurs monétaires liés à la devise de la company active.
 *
 * @return {Object} currency, symbol, fCurrency, eCurrency liés à la devise active
 */
export function useCurrencyFormatter() {
  const currency = useSessionStore((state) => state.activeCompany?.currency || 'EUR');

  return {
    currency,
    symbol: getCurrencySymbol(currency),
    fCurrency: (amount) => fCurrency(amount, currency),
    eCurrency: (amount) => eCurrency(amount, currency),
  };
}
